import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const occasionKeys = [
  { emoji: "🎂", key: "birthday" },
  { emoji: "👶", key: "baby" },
  { emoji: "🙏", key: "thankYou" },
  { emoji: "💒", key: "wedding" },
  { emoji: "🎓", key: "graduation" },
  { emoji: "👋", key: "farewell" },
  { emoji: "💐", key: "getWell" },
  { emoji: "✈️", key: "bonVoyage" },
];

const Occasions = () => {
  const { t } = useTranslation();
  return (
    <section id="occasions" className="py-28 bg-background border-t border-border/40">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <h2 className="text-3xl md:text-5xl font-extralight text-foreground tracking-tight">
            {t("occasionsSection.title")}
          </h2>
          <p className="mt-6 text-muted-foreground max-w-lg mx-auto text-base font-light">
            {t("occasionsSection.subtitle")}
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
          {occasionKeys.map((occ, i) => (
            <motion.button
              key={occ.key}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              whileHover={{ y: -2 }}
              className="flex flex-col items-center gap-4 p-8 rounded-xl bg-background border border-border/60 cursor-pointer transition-all hover:border-foreground/20"
            >
              <span className="text-3xl">{occ.emoji}</span>
              <span className="font-light text-xs text-foreground tracking-wide">{t(`occasions.${occ.key}`)}</span>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Occasions;
